import { useQuery } from 'react-query';
import http from '../config/http-service';
import type { MasterProductMergePlan } from './types';
import { masterProductsEndpoint } from './use-get-master-products-api';

// GET ums/v1/cms/master-products/:loserId/merge-plan?survivorId=N
//
// Raw useQuery rather than useQueryWrapper, mirroring useGetMasterProductUsageApi: a
// failed plan is rendered inline in the modal, not toasted. retry:false so a 4xx from a
// bad pair surfaces immediately instead of after three attempts.
export const useGetMasterProductMergePlanApi = (
  loserId?: number,
  survivorId?: number,
  options: { enabled?: boolean } = {}
) => {
  return useQuery({
    queryKey: [masterProductsEndpoint, 'merge-plan', loserId, survivorId],
    queryFn: async (): Promise<MasterProductMergePlan> => {
      const { data } = await http.get(`${masterProductsEndpoint}/${loserId}/merge-plan`, {
        params: { survivorId },
      });
      // The API wraps the resource in an envelope: { data: {...} }.
      return data?.data ?? data;
    },
    enabled: (options.enabled ?? true) && !!loserId && !!survivorId,
    retry: false,
  });
};
